import * as api from '../../../clients/veranstaltungen';

import {Action} from '@ngrx/store';

export const GET_FUNKPROTOKOLL_IDENTIFIER = '[VeranstaltungenModul] GetFunkprotokollIdentifier laden';
export const GET_FUNKPROTOKOLL_IDENTIFIER_AUSFUEHREN = '[VeranstaltungenModul] GetFunkprotokollIdentifier ausführen';
export const GET_FUNKPROTOKOLL_IDENTIFIER_ERFOLGREICH = '[VeranstaltungenModul] GetFunkprotokollIdentifier laden erfolgreich';
export const GET_FUNKPROTOKOLL_IDENTIFIER_FEHLER = '[VeranstaltungenModul] GetFunkprotokollIdentifier Ladefehler';
export const GET_FUNKPROTOKOLL_IDENTIFIER_NICHT_AUSGEFUEHRT = '[VeranstaltungenModul] GetFunkprotokollIdentifier nicht ausgeführt (evtl. Offline)';


export class GetFunkprotokollIdentifierAction implements Action {
    readonly type = GET_FUNKPROTOKOLL_IDENTIFIER;
        constructor(public optPayload: any = null) {}
    }
export class GetFunkprotokollIdentifierAusfuehrenAction implements Action {
    readonly type = GET_FUNKPROTOKOLL_IDENTIFIER_AUSFUEHREN;
        constructor(public optPayload: any = null) {}
    }
export class GetFunkprotokollIdentifierErfolgreichAction implements Action {
    readonly type = GET_FUNKPROTOKOLL_IDENTIFIER_ERFOLGREICH;
        constructor(public payload: api.FunkprotokollIdentifier, public optPayload: any = null) {}
    }
export class GetFunkprotokollIdentifierFehlerAction implements Action {
    readonly type = GET_FUNKPROTOKOLL_IDENTIFIER_FEHLER;
        constructor(public payload: any, public optPayload: any = null) {}
    }
export class GetFunkprotokollIdentifierNichtAusgefuehrtAction implements Action {
    readonly type = GET_FUNKPROTOKOLL_IDENTIFIER_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type VeranstaltungenQueryFunkprotokollIdentifierActions =
    GetFunkprotokollIdentifierAction
    | GetFunkprotokollIdentifierAusfuehrenAction
    | GetFunkprotokollIdentifierErfolgreichAction
    | GetFunkprotokollIdentifierFehlerAction
    | GetFunkprotokollIdentifierNichtAusgefuehrtAction
    ;
